resourcePaths = '{"rootPath":"","assetsPath":""}';/*
    SchemaAdapter

    Adapter class that converts a JSON Validation Schema (http://json-schema.org/draft-04/schema)
    into a validation object for the mogo-ui-lib Validation component.

    Arguments:
        schema (required) [object || string]:
            Object representing a JSON Validation Schema or a URL string to request the
            JSON Validation Schema
        errorStrObj (optional) [object]:
            Object of error strings corresponding to fields and error keys

*/
function SchemaAdapter(schema, errorStrObj, formId) {

    this._schema = null;
    this._errorStrObj;
    this._formNode;
    this.Assert = Validator.Assert;
    this.form = true;

    // Map of schema validation properties <-> schema validation error keys
    this._errorKeyMap = {
        "enum": "json_schema_error_enum",
        "maximum": "json_schema_error_maximum",
        "minimum": "json_schema_error_minimum",
        "maxLength": "json_schema_error_maxLength",
        "minLength": "json_schema_error_minLength",
        "pattern": "json_schema_error_pattern",
        "required": "json_schema_error_required_property_missing",
        "type": "json_schema_error_type_no_match_single"
    };

    /*
        GET schema if URL to schema is provided,
        or assign schema to this._schema if schema is provided
    */
    this.constructor = function(schema, errorStrObj, formId) {
        if (typeof schema == "object") {
            this._schema = schema;
        } else if (typeof schema == "string") {
            // URL
        }

        if (formId instanceof Node) {
            this._formNode = formId;
        } else {
            this._formNode = $("#" + formId);
            if (this._formNode.length == 0)
                this._formNode = $("body")[0];
            else
                this._formNode = this._formNode[0];
        }
        this._errorStrObj = errorStrObj;
    };

    /*
        Generates a validation object from provided schema.

        Returns:
            Validation object (used as a parameter for the Validation component).
    */
    this.generateValidationObj = function() {
        var validationObj = new Object();

        // Get field names, store required property in object
        var requiredFields = new Object();
        for (var i = 0; i < this._schema.required.length; i++)
            requiredFields[this._schema.required[i]] = true;
        var fields = this._schema.properties;

        // Go through each field specified in JSON Validation schema
        for (var name in fields) {
            var fieldObj = fields[name];
            validationObj[name] = new Object();
            validationObj[name].assertions = new Array();

            // Error object
            var fieldErrObj = this._errorStrObj[name];

            // Required adaptation
            if (requiredFields[name] != null) {
                var type = fieldObj.type;
                var assertion = this._createAssertionForRequired(name, type);

                validationObj[name].assertions[validationObj[name].assertions.length] =
                {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.required != undefined) {
                    var errObj = this._createErrorObjectForType(name, "required");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            // Type adaptation
            if (fieldObj.type != null) {
                var assertion = this._createAssertionForType(name, fieldObj.type);
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.type != undefined) {
                    var errObj = this._createErrorObjectForType(name, "type");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            // Enum adaptation
            if (fieldObj.enum != null) {
                var assertion = this._createAssertionForEnum(name, fieldObj.enum);
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.enum != undefined) {
                    var errObj = this._createErrorObjectForType(name, "enum");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            // Pattern adaptation
            if (fieldObj.pattern != null) {
                var assertion = this._createAssertionForPattern(name, fieldObj.pattern);
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.pattern != undefined) {
                    var errObj = this._createErrorObjectForType(name, "pattern");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            // Minimum and exclusiveMininum adaptation
            if (fieldObj.minimum != null) {
                var assertion;
                if (fieldObj.exclusiveMinimum != null && fieldObj.exclusiveMinimum === true) {
                    assertion = this._createAssertionForMinimum(name, fieldObj.minimum, true);
                } else {
                    assertion = this._createAssertionForMinimum(name, fieldObj.minimum, false);
                }
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.minimum != undefined) {
                    var errObj = this._createErrorObjectForType(name, "minimum");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            // Maximum and exclusiveMaximum adapation
            if (fieldObj.maximum != null) {
                var assertion;
                if (fieldObj.exclusiveMaximum != null && fieldObj.exclusiveMaximum === true) {
                    assertion = this._createAssertionForMaximum(name, fieldObj.maximum, true);
                } else {
                    assertion = this._createAssertionForMaximum(name, fieldObj.maximum, false);
                }
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};

                if (fieldErrObj != undefined && fieldErrObj.maximum != undefined) {
                    var errObj = this._createErrorObjectForType(name, "maximum");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            //Minimum Length adaptation
            if (fieldObj.minLength != null) {
                var assertion = this._createAssertionForMinLength(name, fieldObj.minLength);
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};
                if (fieldErrObj != undefined && fieldErrObj.minLength != undefined) {
                    var errObj = this._createErrorObjectForType(name, "minLength");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }

            //Maximum Length adaptation
            if (fieldObj.maxLength != null) {
                var assertion = this._createAssertionForMaxLength(name, fieldObj.maxLength);
                validationObj[name].assertions[validationObj[name].assertions.length] = {assertion: assertion};
                if (fieldErrObj != undefined && fieldErrObj.maxLength != undefined) {
                    var errObj = this._createErrorObjectForType(name, "maxLength");
                    validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                }
            }


            if (fieldObj.allOf != null) {

                for (i = 0; i < fieldObj.allOf.length; i++) {

                    if (fieldObj.allOf[i].type != undefined) {
                        var assertion = this._createAssertionForType(name, fieldObj.allOf[i].type);
                        validationObj[name].assertions[validationObj[name].assertions.length] = {
                            assertion: assertion
                        };
                        if (fieldErrObj != undefined && fieldObj.allOf[i].type != undefined) {
                            var errObj = this._createErrorObjectForType(name, "type");
                            validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                        }
                    }

                    if (fieldObj.allOf[i].pattern != undefined) {
                        var assertion = this._createAssertionForPattern(name, fieldObj.allOf[i].pattern);
                        validationObj[name].assertions[validationObj[name].assertions.length] = {
                            assertion: assertion
                        };
                        if (fieldErrObj != undefined && fieldObj.allOf[i].pattern != undefined) {
                            var errObj = this._createErrorObjectForType(name, "pattern");
                            validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                        }
                    }

                    if (fieldObj.allOf[i].not != null) {

                        if (fieldObj.allOf[i].not.anyOf.length != null) {

                            for (z = 0; z < fieldObj.allOf[i].not.anyOf.length; z++) {
                                if ( fieldObj.allOf[i].not.anyOf[z].type != undefined ) {
                                    var assertion = this._createAssertionForType(name, fieldObj.allOf[i].not.anyOf[z].type);
                                    validationObj[name].assertions[validationObj[name].assertions.length] = {
                                        assertion: assertion
                                    };
                                    if (fieldErrObj != undefined && fieldObj.allOf[i].not.anyOf[z].type != undefined) {
                                        var errObj = this._createErrorObjectForType(name, "type");
                                        validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                                    }
                                }
                                if ( fieldObj.allOf[i].not.anyOf[z].pattern != undefined ) {
                                    var assertion = this._createAssertionAgainstPattern(name, fieldObj.allOf[i].not.anyOf[z].pattern);
                                    validationObj[name].assertions[validationObj[name].assertions.length] = {
                                        assertion: assertion
                                    };
                                    if (fieldErrObj != undefined && fieldObj.allOf[i].not.anyOf[z].pattern != undefined) {
                                        var errObj = this._createErrorObjectForType(name, "pattern");
                                        validationObj[name].assertions[validationObj[name].assertions.length - 1].error = errObj;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return validationObj;
    };

    /*
        Converts required property in schema for validation object

        Returns:
            An array of Assert objects that corresponds to the required property.
    */
    this._createAssertionForRequired = function(fieldName, type) {
        if(this.form){
            var field = $("[name='" + fieldName + "']", this._formNode).mogo();
            if (field.declaredClass == "TextField" || field.declaredClass == "InputText" || field.extends[0] == "InputText") {
                if (type != "string")
                    return [new this.Assert().NotNull()];
                return [new this.Assert().NotBlank()];
            } else if (field.declaredClass == "Select" || field.declaredClass == "BooleanGroup") {
                return [new this.Assert().NotNull()];
            } else if (field.declaredClass == "Checkbox" || field.declaredClass == "Radio") {
                return [new this.Assert().Choice([true, false])];
            }
            return [];
        } else {
            return [new this.Assert().NotNull()];
        }
    };

    /*
        Checks type property for an array before creating validation asserts

        Returns:
            An array of Assert objects that corresponds to the type property.
    */
    this._createAssertionForType = function(fieldName, type) {
        if ($.isArray(type)) {
            for (var i = 0; i < type.length; i++) {
                if (type[i] != "null") {
                    return this._createTypeAssertion(type[i]);
                }
            }
        } else {
            return this._createTypeAssertion(type);
        }
    };

    /*
        Converts type property in schema for validation object

        Returns:
            An array of Assert objects that corresponds to the type property.
    */
    this._createTypeAssertion = function(type){
        if (type == "string") {
            return [ new this.Assert().IsString() ];
        } else if (type == "integer") {
            return [ new this.Assert().Integer() ];
        } else if (type == "number") {
            return [ new this.Assert().Callback(function(value) {
                if (isNaN(parseInt(value)) || isNaN(value)) return false;
                return true;
            }) ];
        } else if (type == "boolean") {
            return [ new this.Assert().Callback(function(value) {
                return typeof value == "boolean";
            }) ];
        } else if (type == "array") {
            return [ new this.Assert().Callback(function(value) {
                return value instanceof Array;
            }) ];
        } else if (type == "null") {
            return [ new this.Assert().Null() ];
        } else if (type == "object") {
            return [ new this.Assert().Callback(function(value) {
                return typeof value == "object";
            }) ];
        }
        return [];
    }

    /*
        Converts enum property in schema for validation object

        Returns:
            An array of Assert objects that corresponds to the enum property.
    */
    this._createAssertionForEnum = function(fieldName, enumArray) {
        return [new this.Assert().Choice(enumArray)];
    };

    /*
        Converts pattern property in schema for validation object when the desired match is true

        Returns:
            An array of Assert objects that corresponds to the pattern property.
    */
    this._createAssertionForPattern = function(fieldName, pattern) {
        return [new this.Assert().Regexp(pattern)];
    };

    /*
        Converts pattern property in schema for validation object when the desired match is false

        Returns:
            An array of Assert objects that corresponds to the pattern property.
    */

    this._createAssertionAgainstPattern = function(fieldName, pattern) {
        return [ new this.Assert().NotRegexp(pattern) ];
    };

    /*
        Converts minimum and exclusiveMinimum properties in schema for validation object

        Returns:
            An array of Assert objects that correspond to the minimum and exclusiveMinimum properties.
    */
    this._createAssertionForMinimum = function(fieldName, minimum, exclusive) {
        if (exclusive) {
            return [new this.Assert().GreaterThan(minimum)];
        } else {
            return [new this.Assert().GreaterThanOrEqual(minimum)];
        }
    };

    /*
        Converts maximum and exclusiveMaximum properties in schema for validation object

        Returns:
            An array of Assert objects that correspond to the maximum and exclusiveMaximum properties.
    */
    this._createAssertionForMaximum = function(fieldName, maximum, exclusive) {
        if (exclusive) {
            return [new this.Assert().LessThan(maximum)];
        } else {
            return [new this.Assert().LessThanOrEqual(maximum)];
        }
    };

    /*
        Converts minLength in schema for validation object

        Returns:
            An array of Assert objects that correspond to minLength property.
    */
    this._createAssertionForMinLength = function(fieldName, minLength){
        return [new this.Assert().Length({min: minLength})];
    };

    /*
        Converts maxLength in schema for validation object

        Returns:
            An array of Assert objects that correspond to maxLength property.
    */
    this._createAssertionForMaxLength = function(fieldName, maxLength){
        return [new this.Assert().Length({max: maxLength})];
    };

    /*
        Retrieves the error key for the type of error.

        Returns:
            The error object with a key-value pair for use in the validationObj
    */
    this._createErrorObjectForType = function(fieldName, errorType) {
        var errObj = {};
        if (this._errorKeyMap[errorType] != undefined) {
            errObj[this._errorKeyMap[errorType]] = this._errorStrObj[fieldName][errorType];
        }

        return errObj;
    };

    this.constructor(schema, errorStrObj, formId);
}
